import { Buffer } from 'buffer';
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

// export const reportLicenseKey =
//     "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkq9+trkyNes0G2jv5rfsD4naRAXWfNmczwQj06SdOQ2YjDdF6+wtjOAKZlbSR/xM7EJ6GIvkKCJj/qSE" +
//     "1Riyl7oJt65+fAXJSIUmq8md+8Mo+cmAFpUzCIUoYLFBDBF1DjkhajxVbHHwPB8sWuNl89GJ1aefW1TRx+uk/2V/xZpJ6UUlk5gQX17ocelu5bEfg9ii1335Ji" +
//     "2PyuS52Nly91vV50pCgAkPBO3/XQKSd+qmZwYKl3NUYg7+WPufNNFw2UDyOGBjjpVUbFqMp7KbVoZBK+Fz6E0TyomrelCpMfu0q00YM3EnvEhJBzaOGiCJnYCO" +
//     "O16NBJ6vVXrjTAcuUz5IOrIl04vYd1UkzWaSEC/Iyej9D7hSVR6G12TyWB33pCCDfhVjVeSDN9LxBMNMnkqZe7aZbFx9lHyUasst4Q2gRDkoexTFGGJNR7u6gQ" +
//     "i/H/vK4y+QmMGzifWcjQwfVsgN0OSwOQYTtW1e6a58nhou+wMsyeLrqSFcgKjIAWeweXQAhoauEuBR61avPk1LH/Qvn2XUAKBu93joe4vI9VFQ==";

export function getReportLicenseKey() {
    const b = [
        0xEA, 0xF2, 0x61, 0x1A, 0xD2, 0xCB, 0x2F, 0x3D, 0x86, 0x36, 0xF8, 0x96, 0x99, 0x44, 0xEB, 0x85, 0x2A, 0xA7, 0x38, 0x8B, 0x5D, 0x0F, 0x08, 0xC1,
        0xCA, 0x54, 0x33, 0x41, 0xC0, 0x0E, 0x88, 0x79, 0x2A, 0xF7, 0xEB, 0x6B, 0x93, 0x23, 0x5E, 0xB3, 0x41, 0xB6, 0x8E, 0xFE, 0x6B, 0x7E, 0xC0, 0xF8,
        0x9D, 0xA4, 0x40, 0x5D, 0x67, 0xCD, 0x99, 0xCC, 0xF0, 0x42, 0x3D, 0x3A, 0x49, 0xD3, 0x90, 0xD9, 0x88, 0xC3, 0x74, 0x5E, 0xBE, 0xC2, 0xD8, 0xCE,
        0x00, 0xA6, 0x65, 0x6D, 0x24, 0x7F, 0xC4, 0xCE, 0xC4, 0x27, 0xA1, 0x88, 0xBE, 0x42, 0x82, 0x26, 0x3F, 0xEA, 0x48, 0x4D, 0x51, 0x8B, 0x29, 0x7B,
        0xA0, 0x9B, 0x7A, 0xE7, 0xE7, 0xC0, 0x5C, 0x94, 0x88, 0x52, 0x6A, 0xBC, 0x99, 0xDF, 0xBC, 0x32, 0x8F, 0x9C, 0x98, 0x01, 0x69, 0x53, 0x30, 0x88,
        0x52, 0x86, 0x0B, 0x14, 0x10, 0xC1, 0x17, 0x50, 0xE3, 0x92, 0x16, 0xA3, 0xC5, 0x56, 0xC7, 0x1F, 0x03, 0xC1, 0xF2, 0xC5, 0xAE, 0x36, 0x5F, 0x3D,
        0x18, 0x9D, 0x5A, 0x79, 0xF5, 0xB5, 0x4D, 0x1C, 0x7E, 0xBA, 0x4F, 0xF6, 0x57, 0xFC, 0x59, 0xA4, 0x9E, 0x94, 0x52, 0x59, 0x39, 0x81, 0x05, 0xF5,
        0xEE, 0x87, 0x1E, 0x96, 0xEE, 0x5B, 0x11, 0xF8, 0x3D, 0x8A, 0x2D, 0x77, 0xDF, 0x92, 0x62, 0xD8, 0xFC, 0xAE, 0x4B, 0x9D, 0x8D, 0x97, 0x2F, 0x75,
        0xBD, 0x5E, 0x74, 0xA4, 0x28, 0x00, 0x90, 0xF0, 0x4E, 0xDF, 0xF5, 0xD0, 0x29, 0x27, 0x7E, 0xAA, 0x66, 0x70, 0x60, 0xA9, 0x77, 0x35, 0x46, 0x20,
        0xEF, 0xE5, 0x8F, 0xB9, 0xF3, 0x4D, 0x17, 0x0D, 0x94, 0x0F, 0x23, 0x86, 0x06, 0x38, 0xE9, 0x55, 0x46, 0xC5, 0xA8, 0xCA, 0x7B, 0x29, 0xB5, 0x68,
        0x64, 0x12, 0xBE, 0x17, 0x3E, 0x84, 0xD1, 0x3C, 0xA8, 0x9A, 0xB7, 0xA5, 0x0A, 0x93, 0x1F, 0xBB, 0x4A, 0xB4, 0xD1, 0x83, 0x37, 0x12, 0x7B, 0xC4,
        0x84, 0x90, 0x73, 0x68, 0xE1, 0xA2, 0x08, 0x99, 0xD8, 0x08, 0xE3, 0xB5, 0xE8, 0xD0, 0x49, 0xEA, 0xF5, 0x57, 0xAE, 0x34, 0xC0, 0x72, 0xE5, 0x33,
        0xE4, 0x83, 0xAB, 0x22, 0x5D, 0x38, 0xBD, 0x87, 0x75, 0x52, 0x4C, 0xD6, 0x69, 0x21, 0x02, 0xFC, 0x8C, 0x9E, 0x8F, 0xD0, 0xFB, 0x85, 0x25, 0x51,
        0xE8, 0x6D, 0x76, 0x4F, 0x25, 0x81, 0xDF, 0x7A, 0x42, 0x08, 0x37, 0xE1, 0x56, 0x35, 0x5E, 0x48, 0x33, 0x7D, 0x2F, 0x10, 0x4C, 0x34, 0xC9, 0xE4,
        0xA9, 0x97, 0xBB, 0x69, 0x96, 0xC5, 0xC7, 0xD9, 0x47, 0xC9, 0x46, 0xAC, 0xB2, 0xDE, 0x10, 0xDA, 0x04, 0x43, 0x92, 0x87, 0xB1, 0x4C, 0x51, 0x86,
        0x24, 0xD4, 0x7B, 0xBB, 0xA8, 0x10, 0x8B, 0xF1, 0xFF, 0xBC, 0xAE, 0x32, 0xF9, 0x09, 0x8C, 0x1B, 0x38, 0x9F, 0x59, 0xC8, 0xD0, 0xC1, 0xF5, 0x6C,
        0x80, 0xDD, 0x0E, 0x4B, 0x03, 0x90, 0x61, 0x3B, 0x56, 0xD5, 0xEE, 0x9A, 0xE7, 0xC9, 0xE1, 0xA2, 0xEF, 0xB0, 0x32, 0xCC, 0x9E, 0x2E, 0xBA, 0x92,
        0x15, 0xC8, 0x0A, 0x8C, 0x80, 0x16, 0x7B, 0x07, 0x97, 0x40, 0x08, 0x68, 0x6A, 0xE1, 0x2E, 0x05, 0x1E, 0xB5, 0x6A, 0xF3, 0xE4, 0xD4, 0xB1, 0xFF,
        0x42, 0xF9, 0xF6, 0x5D, 0x40, 0x0A, 0x06, 0xEF, 0x77, 0x8E, 0x87, 0xB8, 0xBC, 0x8F, 0x55, 0x15
    ];

    return Buffer.from(b).toString('base64');
}

export function getHomePath() {
    return window.location.origin;
}

export function useQueryParams() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export function httpConfig() {
    const accessToken = localStorage.getItem('session_access_token');
    return {
        headers: {
            Authorization: `Bearer ${accessToken ? accessToken : ''}`
        }
    };
}